var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLightRightBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 734.293,
    height: 1000,
    viewBox: "0 0 734.293 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Path_21204",
    "data-name": "Path 21204",
    transform: "translate(56.09)",
    fill: "#042",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 677.703125 999.5 L -55.47380447387695 999.5 L 151.6970367431641 13.55294132232666 L 677.703125 0.5125774145126343 L 677.703125 999.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 677.203125 999 L 677.203125 1.025154829025269 L 152.1049041748047 14.04301166534424 L -54.85790252685547 999 L 677.203125 999 M 678.203125 1000 L -56.08985900878906 1000 L 151.2890167236328 13.06287479400635 L 678.203125 0 L 678.203125 1000 Z",
    stroke: "none",
    fill: "#707070"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightRightBackground);
export default __webpack_public_path__ + "static/media/light_right_background.f6d074f207c9f9e2e8ccebfb04282f4f.svg";
export { ForwardRef as ReactComponent };